import { IconComponent } from "../icon.types";

export const Icon404: IconComponent = (props) => (
  <svg
    width="539"
    height="300"
    viewBox="0 0 539 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M170.158 257.135L188.073 257.572L185.888 199.419H167.099L166.225 1.31141L108.924 2.18495L0.436943 205.097L0 255.825H93.1936L91.8828 298.691L170.22 299.128V257.135H170.158ZM521.023 257.135L538.938 257.572L537.19 199.419H518.401L517.527 1.31141L460.226 2.18495L351.739 205.097L351.302 255.825H444.496L443.185 298.691L521.522 299.128L521.085 257.135H521.023ZM456.73 77.4345L446.68 200.729L401.176 201.603L456.73 77.4345ZM267.284 300.001C315.847 300.438 342.064 216.453 346.496 177.58C352.176 130.346 344.311 -0.435681 273.401 0.00109136C208.234 0.437863 192.879 104.078 193.316 150.875C193.316 192.867 206.861 299.564 267.222 300.001H267.284ZM278.645 195.051C287.82 178.017 290.442 148.691 290.442 129.473C290.005 113.749 287.82 89.6641 280.392 76.1242C275.586 67.3888 268.158 64.7681 262.478 73.5036C256.361 82.6758 253.302 98.3996 251.991 109.381C248.933 131.22 248.496 179.327 262.041 198.171C268.595 206.906 273.838 203.412 278.645 195.113V195.051ZM105.428 77.4345L95.3784 200.729L49.8739 201.603L105.428 77.4345Z"
      fill="currentColor"
    />
  </svg>
);
